import React from "react";
import "./AccessDenied.css";
import Logo from "../../assets/images/amtex_logo.png";

export default function AccessDenied() {
  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL || "contato@brangemedia.com";

  const handleEmailRedirect = () => {
    window.location.href = `mailto:${supportEmail}?subject=Acesso%20Negado%20-%20Solicitação%20de%20Acesso&body=Olá%20equipe,%0A%0ANão%20estou%20conseguindo%20acessar%20a%20página.%20Poderiam%20me%20ajudar?%0A%0AObrigado.`;
  };

  return (
    <div className="split-denied-page">
      <div className="denied-left-panel">
        <div className="denied-logo-wrapper">
          <img src={Logo} alt="Logo" className="denied-logo" />
        </div>

        <div className="denied-animated-background">
          <div className="denied-wave"></div>
          <div className="denied-wave"></div>
          <div className="denied-wave"></div>
        </div>
      </div>

      <div className="denied-right-panel">
        <h1 className="denied-code-animated">403</h1>
        <p className="denied-message">Seu usuário não tem acesso a esta página</p>

        <p className="denied-description">
          Você não tem autorização para acessar esta área.
          <br />
          Entre em contato com o suporte por meio do e-mail{" "}
          <span className="denied-email">{supportEmail}</span>
          <br />
          ou clique no botão abaixo para enviar um e-mail automaticamente.
        </p>

        <button className="denied-action-button" onClick={handleEmailRedirect}>
          Enviar e-mail ao suporte
        </button>
      </div>
    </div>
  );
}
